<template>
  <div class="eleicao-conselho">
    <div class="row">
      <public-header :title="'Detalhes do Candidato'" class="public-header">
        <div class="col-xs-12 col-sm-4 col-md-3">
          <img
            :src="candidato.url_foto"
            alt="Imagem do candidato a conselheiro tutelar"
          />
        </div>
        <div class="col-xs-12 col-sm-8 col-md-9">
          <p id="dados-candidato">
            {{ candidato.posicao }}º COLOCADO<br />
            {{ candidato.numero }} - {{ candidato.nome }}<br />
            {{ candidato.total_votos.toLocaleString() }} votos no total<br />
            {{
              (
                (Number(candidato.total_votos) / total_votos.total_nominais) *
                100
              ).toFixed(2)
            }}
            % dos votos nominais
          </p>
        </div>
      </public-header>
    </div>
    <div class="container">
      <Breadcrumb :links="breadcrumb" />
      <div class="row">
        <div class="col-xs-12">
          <h3>
            Votos por Seção
          </h3>
        </div>
        <div
          class="col-xs-12 col-md-6"
          v-for="(voto, index) in votos"
          :key="`votos-${index}`"
          :class="'wrapper-secao'"
        >
          <router-link
            :to="{
              name: 'secao_conselho',
              params: {
                secao: voto.numero
              }
            }"
          >
            <h4>Seção {{ voto.numero }}</h4>
          </router-link>
          <p class="detalhes-secao">
            <span>Unidade:</span> {{ voto.unidade }}<br />
            {{ voto.endereco }}<br />
            <span>Votos Nominais:</span>
            {{ voto.total_nominais.toLocaleString() }}<br />
            <span>Votos Recebidos:</span>
            {{ findVotoCandidato(voto).total_votos.toLocaleString() }}
            ({{
              (
                (findVotoCandidato(voto).total_votos / voto.total_nominais) *
                100
              ).toFixed(2)
            }}
            %)<br />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PublicHeader, Breadcrumb } from '../../../components'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    PublicHeader,
    Breadcrumb
  },
  created() {
    const { candidato } = this.$route.params

    if (!candidato) {
      this.$router.push({ name: 'eleicao_conselho' })
    } else {
      this.candidato = this.candidatos.find(item => {
        return item.numero === candidato.numero
      })
    }
  },
  data() {
    return {
      isLoading: true,
      candidato: {
        total_votos: 0
      }
    }
  },
  methods: {
    findVotoCandidato(secao) {
      const finder = voto => {
        return voto.candidato_id === this.candidato.id
      }

      return secao.votos.find(finder)
    }
  },
  computed: {
    ...mapState({
      candidatos: ({ eleicoes_conselho }) => eleicoes_conselho.candidatos,
      votos: ({ eleicoes_conselho }) => eleicoes_conselho.votos
    }),
    ...mapGetters({
      total_votos: 'votosTotais'
    }),
    breadcrumb() {
      return [
        {
          label: 'Eleições - Conselho Tutelar',
          named_link: { name: 'eleicao_conselho' }
        },
        {
          label: `${this.candidato.numero} - ${this.candidato.nome}`
        }
      ]
    }
  }
}
</script>

<style scoped>
.eleicao-conselho img {
  border-radius: 30px;
}

#dados-candidato {
  font-size: 1.5em;
}

.detalhes-secao {
  font-size: 1.2em;
}
.detalhes-secao span {
  font-weight: 600;
}
.wrapper-secao {
  min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/public/eleicao_conselho/DetalheCandidato.vue